export const getBillTypeMapping = {
    "PL" : "Packing List",
    "ORD" : "Order",
    "DIR" : "Direct",
    "STK" : "Stock",
    "VCN" : "Credit Note",
    "VDN" : "Debit Note"
}

export const getBillTypeWord = (billType) => {
    return getBillTypeMapping[billType] || "Unknown";
}